import React from "react";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

const OverviewDashboardShimmer = () => {
  return (
    <>
      <div className="mb_20">
        <ShimmerSimpleGallery card imageHeight={227} row={1} col={3} />
      </div>
      <div className="mb_20">
        <div className="d-flex gap-4">
          <ShimmerSimpleGallery card imageHeight={207} row={1} col={2} />
          <ShimmerSimpleGallery card imageHeight={207} row={1} col={2} />
        </div>
      </div>
      <div className="mb_20">
        <div className="d-flex gap-4">
          <ShimmerSimpleGallery card imageHeight={207} row={2} col={2} />
          <ShimmerSimpleGallery card imageHeight={207} row={2} col={2} />
        </div>
      </div>
      <div className="mb_20">
        <ShimmerSimpleGallery card imageHeight={400} row={1} col={1} />
      </div>
    </>
  );
};

export default OverviewDashboardShimmer;
